import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import ROUTES from '../../constants/routeUrls';
import AppStore from '../../store/AppStore';
import AuthStore from '../../store/AuthStore';
import ModalStore from '../../store/ModalStore';
import RouterStore from '../../store/RouterStore';
import FileUploadModalService from '../modals/file-upload-modal/FileUploadModalService';
import AboutModal from '../modals/about-modal';
import { useOnClickOutside } from '@app/src/common/hooks/useOnClickOutside';
import ProfileIcon from './assets/profile.svg';

import './ProfileMenu.scss';

interface IProps {
  className?: string;
}

const ProfileMenu = ({ className }: IProps) => {
  const [open, seOpen] = useState(false);
  const anchorEl = useRef<HTMLDivElement>(null);

  const handleClose = () => seOpen(false);
  useOnClickOutside(anchorEl, handleClose);

  const toggleMenu = () => seOpen(!open);

  const handleLogOutClick = () => {
    FileUploadModalService.closeModal();
    const isExternal = AuthStore.isExternalUser;
    AuthStore.clearData();
    AppStore.logOut();
    RouterStore.clearRoutes();
    RouterStore.navigate(
      isExternal ? ROUTES.logOutPage.path : ROUTES.authPage.path
    );
  };

  const handleProfileClick = () => {
    handleClose();
    RouterStore.navigate(ROUTES.profilePage.path);
  };

  const handleAboutClick = () => {
    handleClose();
    ModalStore.showModal(modalProps => <AboutModal {...modalProps} />).catch(
      () => null
    );
  };

  useEffect(() => {
    if (!AppStore.user) {
      AppStore.defineUser();
    }
  }, []);

  return (
    <div className={classNames('profile-bar', className)} ref={anchorEl}>
      <div className="profile-bar__avatar" onClick={toggleMenu}>
        {AppStore.avatarString}
      </div>
      {open && (
        <ul className="profile-bar__menu-list">
          <li
            onClick={handleProfileClick}
            className="profile-bar__menu-item profile-bar__menu-item_profile"
          >
            <p className="profile-bar__menu-item-name">{AppStore.fullName}</p>
            <p className="profile-bar__menu-item-email">
              {AppStore.user && AppStore.user.email}
            </p>
            <div className="profile-bar__menu-item-icon">
              <ProfileIcon />
            </div>
          </li>
          <li onClick={handleAboutClick} className="profile-bar__menu-item">
            <FormattedMessage id="toolbar.menu.item.about" />
          </li>
          <li onClick={handleLogOutClick} className="profile-bar__menu-item">
            <FormattedMessage id="toolbar.menu.item.logout" />
          </li>
        </ul>
      )}
    </div>
  );
};

export default observer(ProfileMenu);
